import { DictionaryObject, useFetch } from '@eas/common-web';
import { EvidenceApiUrl } from '@enums';

export function useCalendarEventTypes() {
  return useFetch<DictionaryObject[]>(
    `${EvidenceApiUrl.CALENDAR_EVENT}/types/list`,
    {
      method: 'GET',
      cacheResponse: true,
    }
  );
}
